import { MaintenanceTypeOutputWithStatus } from './maintenance-type-output-with-status.model';


export class MaintenanceTypeSelectByIdOutput implements IMaintenanceTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: MaintenanceTypeOutputWithStatus;

    constructor(data?: IMaintenanceTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? MaintenanceTypeOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintenanceTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMaintenanceTypeSelectByIdOutput {
    status: number;
    message: string;
    data: MaintenanceTypeOutputWithStatus;
}

